(function () {
  function O(h, c) {
    for (var f in c) h.style[f] = c[f];
  }
  function f(h, c, f, q) {
    return isNaN(h) ? c : h < f ? f : h > q ? q : h;
  }
  function Ga(h, c, f) {
    f *= c;
    c = Math.max(h - f, 0);
    h = Math.min(h + f, 255);
    return Math.round(c + Math.random() * (h - c));
  }
  function va(h, c) {
    return 0.2126 * h[c] + 0.7152 * h[c + 1] + 0.0722 * h[c + 2];
  }
  function Ha() {
    var h = document.createElement("canvas"),
      c = h.getContext("2d");
    h.width = h.height = 500;
    c.fillStyle = "gray";
    c.fillRect(0, 0, 500, 500);
    return h.toDataURL();
  }
  function Ia(h, c) {
    var f = document.createElement("canvas"),
      q = f.getContext("2d"),
      G = 0.375 * h,
      P = 0.125 * h;
    f.width = f.height = h;
    q.fillStyle = c;
    q.globalAlpha = 0.125;
    q.translate(h / 2, h / 2);
    for (var la = 0; 8 > la; la++)
      q.beginPath(),
        q.moveTo(G, 0),
        q.arc(G, 0, P, 0, 2 * Math.PI),
        q.fill(),
        (q.globalAlpha += 0.125),
        q.rotate(Math.PI / 4);
    O(f, {
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      margin: "auto",
      width: h + "px",
      height: h + "px",
    });
    return f;
  }
  function P(h, c) {
    function Fa() {
      ma = 0;
      Q.appendChild(W);
      Ka = setInterval(bb, 1e3 / 15);
    }
    function q() {
      W.parentNode == Q && (Q.removeChild(W), clearInterval(Ka));
    }
    function bb() {
      ma += 45;
      W.style[cb] = "rotate(" + ma + "deg)";
    }
    function Ja(a, b) {
      function d() {
        c = (new Date().getTime() - e) / a;
        if (1 > c)
          (l.style.opacity = "" + (new Date().getTime() - e) / a),
            (La = setTimeout(d, 1e3 / b));
        else if (((l.style.opacity = "1"), "onComplete" in g)) g.onComplete();
      }
      var e = new Date().getTime(),
        c,
        g = {};
      d();
      return g;
    }
    function la() {
      da && (X && q(), Ja(300, 60));
    }
    function Y() {
      da ? db() : (X && q(), (Ja(300, 60).onComplete = db));
    }
    function db() {
      if (Ma.hasOwnProperty("onComplete")) Ma.onComplete();
    }
    function ea(a) {
      O(l, { width: "", height: "" });
      a = Q.clientWidth;
      var b = Q.clientHeight,
        d = a / b;
      "fit" == fa
        ? O(
            l,
            d > C
              ? { height: b + "px", width: b * C + "px", left: 0 }
              : { height: a / C + "px", width: a + "px", left: 0 }
          )
        : "cover" == fa
        ? d > C
          ? O(l, { height: a / C + "px", width: a + "px", left: 0 })
          : O(l, {
              height: b + "px",
              width: b * C + "px",
              left: (a - b * C) / 2 + "px",
            })
        : O(l, { left: a < l.width ? (a - l.width) / 2 + "px" : 0 });
    }
    function r() {
      Ma.clear();
      !da && X && Fa();
      na();
    }
    function eb() {
      function a() {
        for (s = new Date().getTime(); f < c; )
          if (((g += va(e, f)), (f += 4), 17 < new Date().getTime() - s)) {
            I = setTimeout(a, 0);
            return;
          }
        ga = (4 * g) / (255 * c);
        Na();
      }
      var b = document.createElement("canvas"),
        d = b.getContext("2d");
      b.width = k.width;
      b.height = k.height;
      d.fillStyle = "white";
      d.fillRect(0, 0, b.width, b.height);
      var wrh = 1.5;
      var newWidth = k.width;
      var newHeight = newWidth/wrh;
      if(newHeight > k.height){
        newHeight = k.height;
        newWidth = newHeight * wrh ;
      }
      d.drawImage(k, 0, 0, newWidth, newHeight, 0, 0, b.width, b.height);
      var e = d.getImageData(0, 0, b.width, b.height).data,
        c = e.length,
        g = 0,
        f = 0;
      a();
    }
    function wa(a) {
      var b = 255 * oa;
      return (
        "rgba(" +
        Ga(a.r, b, pa) +
        "," +
        Ga(a.g, b, qa) +
        "," +
        Ga(a.b, b, ra) +
        "," +
        a.a +
        ")"
      );
    }
    function F() {
      Z = va(ha, m);
      $[z](n, v, Z);
    }
    function xa() {
      0 > K
        ? (Z = Oa = va(ha, m))
        : ((Pa = va(ha, m)), (Z = (Oa + Pa) / 2), (Oa = Pa));
      $[z](n, v, Z);
      return Z;
    }
    function Qa() {
      for (s = new Date().getTime(); m < R; )
        if (
          (n > p.width - 1 && ((v += L), (n = 0)),
          d.beginPath(),
          x(),
          d.fill(),
          n++,
          (m += 4),
          17 < new Date().getTime() - s)
        ) {
          I = setTimeout(Qa, 0);
          return;
        }
      Y();
    }
    function fb() {
      d.beginPath();
      for (s = new Date().getTime(); m < R; )
        if (
          (n > p.width - 1 && ((v += L), (n = 0)),
          x(),
          n++,
          (m += 4),
          17 < new Date().getTime() - s)
        ) {
          d.fill();
          I = setTimeout(fb, 0);
          return;
        }
      d.fill();
      Y();
    }
    function Ra() {
      for (s = new Date().getTime(); m < R; )
        if (
          (n > p.width - 1 && ((v += L), (n = 0)),
          (d.fillStyle = wa(sa)),
          d.beginPath(),
          x(),
          d.fill(),
          n++,
          (m += 4),
          17 < new Date().getTime() - s)
        ) {
          I = setTimeout(Ra, 0);
          return;
        }
      Y();
    }
    function Sa() {
      for (s = new Date().getTime(); m < R; ) {
        if (n > p.width - 1) {
          if ((t = !t)) d.beginPath(), F(), d.fill();
          v += L;
          n = t ? 0 : -0.5;
          x = t ? F : xa;
          K = -1;
        }
        d.beginPath();
        K = x();
        d.fill();
        n++;
        m += 4;
        if (17 < new Date().getTime() - s) {
          I = setTimeout(Sa, 0);
          return;
        }
      }
      t = !0;
      x = F;
      Y();
    }
    function gb() {
      d.beginPath();
      for (s = new Date().getTime(); m < R; )
        if (
          (n > p.width - 1 &&
            ((t = !t) && F(),
            (v += L),
            (n = t ? 0 : -0.5),
            (x = t ? F : xa),
            (K = -1)),
          (K = x()),
          n++,
          (m += 4),
          17 < new Date().getTime() - s)
        ) {
          d.fill();
          I = setTimeout(gb, 0);
          return;
        }
      d.fill();
      t = !0;
      x = F;
      Y();
    }
    function Ta() {
      for (s = new Date().getTime(); m < R; ) {
        if (n > p.width - 1) {
          if ((t = !t)) (d.fillStyle = wa(sa)), d.beginPath(), F(), d.fill();
          v += L;
          n = t ? 0 : -0.5;
          x = t ? F : xa;
          K = -1;
        }
        d.fillStyle = wa(sa);
        d.beginPath();
        K = x();
        d.fill();
        n++;
        m += 4;
        if (17 < new Date().getTime() - s) {
          I = setTimeout(Ta, 0);
          return;
        }
      }
      t = !0;
      x = F;
      Y();
    }
    function Na() {
      K = -1;
      oa
        ? ya[z]
          ? Ta()
          : Ra()
        : ya[z]
        ? za
          ? gb()
          : Sa()
        : za
        ? fb()
        : Qa();
    }
    function Ua() {
      s = new Date().getTime();
      D = y;
      for (var a, b; D.width > 2 * k.width; )
        if (
          ((a = document.createElement("canvas")),
          (b = a.getContext("2d")),
          (a.width = D.width / 2),
          (a.height = D.height / 2),
         
          b.drawImage(D, 0, 0, D.width, D.height, 0, 0, a.width, a.height),
          (D = a),
          17 < new Date().getTime() - s)
        ) {
          I = setTimeout(Ua, 0);
          return;
        }
       var wrh = 1.5;
      var newWidth = D.width;
      var newHeight = newWidth/wrh;
      if(newHeight > D.height){
        newHeight = D.height;
        newWidth = newHeight * wrh ;
      }
      hb.drawImage(D, 0, 0, D.width, D.height, 0, 0, k.width, k.height);
      ib();
    }
    function ib() {
      var a = k.width,
        u = k.height,
        e = Math.sin(Va),
        c = Math.cos(Va);
      p.width = u * e + a * c;
      p.height = u * c + a * e;
      A.fillStyle = "white";
      A.fillRect(0, 0, p.width, p.height);
      0 > S ? A.translate(u * e, 0) : A.translate(0, a * e);
      A.rotate(-S);
      A.drawImage(k, 0, 0, k.width, k.height, 0, 0, k.width, k.height);
      A.drawImage(k, 0, 0, 1, k.height, -49, 0, 50, k.height);
      A.drawImage(k, k.width - 1, 0, 1, k.height, k.width - 1, 0, 50, k.height);
      A.drawImage(k, 0, 0, k.width, 1, 0, -49, k.width, 50);
      A.drawImage(k, 0, k.height - 1, k.width, 1, 0, k.height - 1, k.width, 50);
      if (z in Wa) {
        var c = document.createElement("canvas"),
          g = c.getContext("2d");
        c.width = p.width;
        c.height = p.height / L;
         var wrh = 1.5;
      var newWidth = p.width;
      var newHeight = newWidth/wrh;
      if(newHeight > p.height){
        newHeight = p.height;
        newWidth = newHeight * wrh ;
      }
        g.drawImage(p, 0, 0, newWidth, newHeight, 0, 0, c.width, c.height);
        p = c;
        A = g;
      }
      ha = A.getImageData(0, 0, p.width, p.height).data;
      d.fillStyle = Aa;
      c = (l.width + 2 * b) / l.width;
      d.scale(c, c);
      d.translate(-b, -b);
      d.rotate(S);
      0 > S ? d.translate(-u * e * b, 0) : d.translate(0, -a * e * b);
      R = ha.length;
      n = v = m = 0;
      t = !0;
      x = F;
      0.5 == w ? ((ga = 0.5), Na()) : eb();
    }
    function na() {
      la();
      y.removeEventListener("load", na);
      L = z in Wa ? Wa[z] : 1;
      C = jb = y.width / y.height;
      Xa = "none" == aa.toLowerCase() || "transparent" == aa.toLowerCase();
      var a = T,
        u;
      u = document.createElement("canvas");
      u.width = u.height = 1;
      u = u.getContext("2d");
      u.save();
      u.fillStyle = a;
      u.fillRect(0, 0, 1, 1);
      a = u.getImageData(0, 0, 1, 1).data;
      a = { r: a[0], g: a[1], b: a[2], a: a[3] / 255 };
      u.restore();
      u.clearRect(0, 0, 2, 2);
      sa = a;
      Ba = "none" == T.toLowerCase() || "transparent" == T.toLowerCase();
      Ya = M ? kb : lb;
      Za = M ? mb : nb;
      Ca = M ? ob : pb;
      ia = M ? qb : rb;
      $a = M ? sb : tb;
      Ba ? ((Aa = "black"), (oa = 0)) : ((Aa = T), (oa = ta));
      ba
        ? ((l.width = ba),
          N
            ? ((l.height = N), (C = ba / N))
            : (l.height = Math.round(l.width / C)))
        : N
        ? ((l.height = N), (l.width = Math.round(l.height * C)))
        : ((l.width = y.width), (l.height = y.height));
      ea();
      window.addEventListener("resize", ea);
      Xa || ((d.fillStyle = aa), d.fillRect(0, 0, l.width, l.height));
      Ba && (d.globalCompositeOperation = "destination-out");
      k.width = Math.ceil(l.width / b);
      k.height = Math.ceil(l.height / b);
      Ua();
    }
    function ub(a) {
      y.src = Ha();
    }
    function ab() {
      0 < ja.src.indexOf("://cdn.") && (y.crossOrigin = "anonymous");
      y.addEventListener("load", na);
      y.addEventListener("error", ub);
      X && Fa();
      y.src = ja.src;
    }
    var Da = document.getElementById(h);
    if (Da) {
      P.instances[h] && P.instances[h].destroy();
      P.instances[h] = this;
      c || (c = {});
      var ja = c.SOURCE_IMAGE || Ha(),
        z = c.RASTER_TYPE && c.RASTER_TYPE in ya ? c.RASTER_TYPE : "circle",
        U = f(c.RASTER_ANGLE, 45, Ea, G),
        b = f(c.DOT_SIZE, 10, 1, G),
        E = f(c.LINE_SMOOTHING, 3, Ea, G) || vb,
        aa = "CANVAS_COLOR" in c ? c.CANVAS_COLOR : "white",
        T = "DOT_COLOR" in c ? c.DOT_COLOR : "black",
        ta = f(c.DOT_COLOR_RANDOMIZATION, 0, 0, 1),
        pa = f(c.DOT_COLOR_R_RANDOMIZATION, 1, 0, 1),
        qa = f(c.DOT_COLOR_G_RANDOMIZATION, 1, 0, 1),
        ra = f(c.DOT_COLOR_B_RANDOMIZATION, 1, 0, 1),
        ba = c.CANVAS_WIDTH,
        N = c.CANVAS_HEIGHT,
        fa = "SCALE_MODE" in c && c.SCALE_MODE in wb ? c.SCALE_MODE : "fit",
        B = f(c.BRIGHTNESS, 0.5, 0, 1),
        w = f(c.CONTRAST, 0.5, 0, 1),
        M = c.INVERT,
        za = c.ALLOW_TURBO_RENDERING,
        da = "SHOW_RENDERING_PROGRESS" in c ? c.SHOW_RENDERING_PROGRESS : !1,
        X = "USE_PRELOADER" in c ? c.USE_PRELOADER : !0,
        ua = "PRELOADER_COLOR" in c ? c.PRELOADER_COLOR : "gray",
        V = Math.round(f(c.PRELOADER_SIZE, 40, 4, G)),
        U = ((U + 270) % 180) - 90,
        B = 1 < B ? 1 : 0 > B ? 0 : B,
        w = 1 < w ? 1 : 0 > w ? 0 : w;
      V % 2 && V++;
      var e = b / 2,
        ka = b * Math.SQRT1_2,
        Ma = this,
        ca = document.body,
        cb = (function () {
          if ("" === ca.style.transform) return "transform";
          if ("" === ca.style.webkitTransform) return "webkitTransform";
          if ("" === ca.style.mozTransform) return "mozTransform";
          if ("" === ca.style.oTransform) return "oTransform";
          if ("" === ca.style.msTransform) return "msTransform";
          if ("" === ca.style.khtmlTransform) return "khtmlTransform";
        })(),
        Q = (function () {
          var a = document.createElement("div");
          O(a, {
            position: "relative",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            margin: 0,
            userSelect: "none",
            MozUserSelect: "none",
            WebkitUserSelect: "none",
            MsUserSelect: "none",
            KhtmlUserSelect: "none",
            userDrag: "none",
            WebkitUserDrag: "none",
            overflow: "hidden",
            cursor: "default",
          });
          a.setAttribute("unselectable", "on");
          Da.appendChild(a);
          return a;
        })(),
        W = Ia(V, ua),
        ma,
        Ka,
        La,
        I,
        Aa,
        oa,
        sa,
        y = new Image(),
        C,
        jb,
        l = (function () {
          var a = document.createElement("canvas");
          O(a, {
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            margin: "auto",
            opacity: 0,
          });
          Q.appendChild(a);
          return a;
        })(),
        d = l.getContext("2d"),
        k = document.createElement("canvas"),
        hb = k.getContext("2d"),
        p = document.createElement("canvas"),
        A = p.getContext("2d"),
        D,
        ha,
        Z,
        K,
        Oa,
        Pa,
        ga,
        L,
        Xa,
        Ba,
        R,
        m,
        v,
        n,
        s,
        t,
        x,
        H = function (a) {
          a /= 255;
          0.5 != w &&
            ((a = Math.tan((w * Math.PI) / 2) * (a - ga) + ga),
            (a = a > ga ? Math.min(a, 1) : Math.max(a, 0)));
          a += 2 * (B - 0.5);
          return 0 > a ? 0 : 1 < a ? 1 : a;
        },
        Ya,
        Za,
        Ca,
        ia,
        $a,
        lb = function (a, b) {
          return a * Math.sqrt(1 - H(b));
        },
        nb = function (a, b) {
          return a * Math.sqrt(1 - H(b)) * 0.82;
        },
        pb = function (a, b) {
          return a * Math.sqrt(1 - H(b));
        },
        rb = function (a, b) {
          return a * (1 - H(b));
        },
        tb = function (a, b) {
          return a * (1 - Math.sqrt(H(b)));
        },
        kb = function (a, b) {
          return a * (0.08 + 0.9 * Math.pow(H(b), 1.05));
        },
        mb = function (a, b) {
          return a * (0 + 0.8 * Math.pow(H(b), 0.85));
        },
        ob = function (a, b) {
          return a * Math.sqrt(H(b));
        },
        qb = function (a, b) {
          return a * H(b);
        },
        sb = function (a, b) {
          return a * (1 - Math.sqrt(1 - H(b)));
        },
        J,
        g,
        S = (Math.PI * U) / 180,
        Va = Math.abs(S),
        $ = {
          circle: function (a, c, g) {
            if ((J = Ya(ka, g)))
              d.moveTo(b * a + e + ka, b * c + e),
                d.arc(b * a + e, b * c + e, J, 0, 2 * Math.PI);
          },
          circle2: function (a, c, g) {
            if ((J = Za(ka, g)))
              d.moveTo(b * a + e + ka, b * c + e),
                d.arc(b * a + e, b * c + e, J, 0, 2 * Math.PI);
          },
          square: function (a, c, f) {
            (g = Ca(b, f)) &&
              d.rect(b * a + e - g / 2, b * c + e - g / 2, g, g);
          },
          line: function (a, c, f) {
            if ((g = ia(b, f)))
              d.moveTo(b * a - E * b, b * c + e),
                d.lineTo(b * a, b * c + e - g / 2),
                d.lineTo(b * a + b, b * c + e - g / 2),
                d.lineTo(b * a + (1 + E) * b, b * c + e),
                d.lineTo(b * a + b, b * c + e + g / 2),
                d.lineTo(b * a, b * c + e + g / 2),
                d.lineTo(b * a - E * b, b * c + e);
          },
          cell: function (a, c, f) {
            if ((g = $a(b, f)))
              d.moveTo(b * a - E * b, b * c + e),
                d.lineTo(b * a, b * c + e - g / 2),
                d.lineTo(b * a + e - g / 2, b * c + e - g / 2),
                d.lineTo(b * a + e - g / 2, b * c),
                d.lineTo(b * a + e, b * c - E * b),
                d.lineTo(b * a + e + g / 2, b * c),
                d.lineTo(b * a + e + g / 2, b * c + e - g / 2),
                d.lineTo(b * a + b, b * c + e - g / 2),
                d.lineTo(b * a + (1 + E) * b, b * c + e),
                d.lineTo(b * a + b, b * c + e + g / 2),
                d.lineTo(b * a + e + g / 2, b * c + e + g / 2),
                d.lineTo(b * a + e + g / 2, b * c + b),
                d.lineTo(b * a + e, b * c + (1 + E) * b),
                d.lineTo(b * a + e - g / 2, b * c + b),
                d.lineTo(b * a + e - g / 2, b * c + e + g / 2),
                d.lineTo(b * a, b * c + e + g / 2),
                d.lineTo(b * a - E * b, b * c + e);
          },
          triangle: function (a, c, f) {
            if ((g = ia(2 * b, f)))
              d.moveTo(b * a + e - g / 2, b * c + b),
                d.lineTo(b * a + e, b * c + b - g),
                d.lineTo(b * a + e + g / 2, b * c + b),
                d.lineTo(b * a + e - g / 2, b * c + b);
          },
          rhomb: function (a, c, f) {
            if ((g = ia(2 * b, f)))
              d.moveTo(b * a + e, b * c + e - g / 2),
                d.lineTo(b * a + e + g / 2, b * c + e),
                d.lineTo(b * a + e, b * c + e + g / 2),
                d.lineTo(b * a + e - g / 2, b * c + e),
                d.lineTo(b * a + e, b * c + e - g / 2);
          },
          rhomb2: function (a, c, f) {
            if ((g = ia((128 > f ? 1.5 + (0.5 * f) / 128 : 2) * b, f)))
              d.moveTo(b * a + e, b * c + e - g / 2),
                d.lineTo(b * a + e + g / 2, b * c + e),
                d.lineTo(b * a + e, b * c + e + g / 2),
                d.lineTo(b * a + e - g / 2, b * c + e),
                d.lineTo(b * a + e, b * c + e - g / 2);
          },
          hexagon: function (a, c, f) {
            if ((g = Ca(b, f))) {
              J = g / Math.sqrt(3);
              phi1 = -Math.PI / 2;
              d.moveTo(
                b * a + e + J * Math.cos(phi1),
                b * c + e + J * Math.sin(phi1)
              );
              for (f = 1; 6 > f; f++)
                (phi1 = Math.PI * ((f / 6) * 2 - 0.5)),
                  d.lineTo(
                    b * a + e + J * Math.cos(phi1),
                    b * c + e + J * Math.sin(phi1)
                  );
              d.closePath();
            }
          },
        };
      $.square2 = $.square;
      $.triangle2 = $.triangle;
      this.update = function () {
        r();
      };
      this.resize = function () {
        ea();
      };
      this.clear = function () {
        y.removeEventListener("load", na);
        y.removeEventListener("error", ub);
        q();
        clearTimeout(La);
        clearTimeout(I);
        l.width = l.width;
        l.style.opacity = 0;
      };
      this.destroy = function () {
        P.instances[h] = null;
        this.clear();
        window.removeEventListener("resize", ea);
        Da.removeChild(Q);
        Da =
          h =
          c =
          ja =
          z =
          U =
          b =
          E =
          aa =
          T =
          ta =
          pa =
          qa =
          ra =
          ba =
          N =
          fa =
          B =
          w =
          M =
          da =
          X =
          ua =
          V =
          e =
          ka =
          ca =
          cb =
          Q =
          W =
          ma =
          Ka =
          La =
          I =
          Aa =
          oa =
          sa =
          y =
          C =
          l =
          d =
          k =
          hb =
          p =
          A =
          D =
          ha =
          Z =
          K =
          ga =
          L =
          Xa =
          Ba =
          R =
          m =
          v =
          n =
          s =
          t =
          x =
          H =
          Ya =
          Za =
          Ca =
          ia =
          $a =
          lb =
          nb =
          pb =
          rb =
          tb =
          kb =
          mb =
          ob =
          qb =
          sb =
          J =
          g =
          S =
          $ =
          Fa =
          q =
          bb =
          Ja =
          la =
          Y =
          ea =
          r =
          eb =
          wa =
          F =
          xa =
          Qa =
          Ra =
          Sa =
          Ta =
          Na =
          Ua =
          ib =
          na =
          ab =
            null;
        for (propName in this) delete this[propName];
        this.update = this.resize = this.clear = this.destroy = function () {};
      };
      Object.defineProperties(this, {
        sourceImage: {
          get: function () {
            return ja;
          },
          set: function (a) {
            a != ja && (this.clear(), (ja = a || Ha()), ab());
          },
          configurable: !0,
        },
        rasterType: {
          get: function () {
            return z;
          },
          set: function (a) {
            a != z && ((z = a && a in ya ? a : "circle"), r());
          },
          configurable: !0,
        },
        rasterAngle: {
          get: function () {
            return U;
          },
          set: function (a) {
            a != U &&
              ((U = f(a, 45, Ea, G)),
              (S = (Math.PI * (((U + 270) % 180) - 90)) / 180),
              (Va = Math.abs(S)),
              r());
          },
          configurable: !0,
        },
        dotSize: {
          get: function () {
            return b;
          },
          set: function (a) {
            a != b &&
              ((b = f(a, 10, 1, G)), (e = b / 2), (ka = b * Math.SQRT1_2), r());
          },
          configurable: !0,
        },
        lineSmoothing: {
          get: function () {
            return E;
          },
          set: function (a) {
            a != E &&
              ((E = f(a, 3, Ea, G) || vb), ("line" != z && "cell" != z) || r());
          },
          configurable: !0,
        },
        canvasColor: {
          get: function () {
            return aa;
          },
          set: function (a) {
            a != aa && ((aa = a), r());
          },
          configurable: !0,
        },
        dotColor: {
          get: function () {
            return T;
          },
          set: function (a) {
            a != T && ((T = a), r());
          },
          configurable: !0,
        },
        dotColorRandomization: {
          get: function () {
            return ta;
          },
          set: function (a) {
            a != ta && ((ta = f(a, 0, 0, 1)), r());
          },
          configurable: !0,
        },
        dotColorRRandomization: {
          get: function () {
            return pa;
          },
          set: function (a) {
            a != pa && ((pa = f(a, 1, 0, 1)), r());
          },
          configurable: !0,
        },
        dotColorGRandomization: {
          get: function () {
            return qa;
          },
          set: function (a) {
            a != qa && ((qa = f(a, 1, 0, 1)), r());
          },
          configurable: !0,
        },
        dotColorBRandomization: {
          get: function () {
            return ra;
          },
          set: function (a) {
            a != ra && ((ra = f(a, 1, 0, 1)), r());
          },
          configurable: !0,
        },
        canvasWidth: {
          get: function () {
            return ba;
          },
          set: function (a) {
            a != ba && ((ba = a), r());
          },
          configurable: !0,
        },
        canvasHeight: {
          get: function () {
            return N;
          },
          set: function (a) {
            a != N && ((N = a), r());
          },
          configurable: !0,
        },
        scaleMode: {
          get: function () {
            return fa;
          },
          set: function (a) {
            a != fa && a in wb && ((fa = a), ea());
          },
          configurable: !0,
        },
        brightness: {
          get: function () {
            return B;
          },
          set: function (a) {
            a != B &&
              ((B = f(a, 0.5, 0, 1)), (B = 1 < B ? 1 : 0 > B ? 0 : B), r());
          },
          configurable: !0,
        },
        contrast: {
          get: function () {
            return w;
          },
          set: function (a) {
            a != w &&
              ((w = f(a, 0.5, 0, 1)), (w = 1 < w ? 1 : 0 > w ? 0 : w), r());
          },
          configurable: !0,
        },
        invert: {
          get: function () {
            return M;
          },
          set: function (a) {
            a != M && ((M = a), r());
          },
          configurable: !0,
        },
        showRenderingProgress: {
          get: function () {
            return da;
          },
          set: function (a) {
            da = a;
          },
          configurable: !0,
        },
        allowTurboRendering: {
          get: function () {
            return za;
          },
          set: function (a) {
            za = a;
          },
          configurable: !0,
        },
        usePreloader: {
          get: function () {
            return X;
          },
          set: function (a) {
            X = a;
          },
          configurable: !0,
        },
        preloaderColor: {
          get: function () {
            return ua;
          },
          set: function (a) {
            ua = a;
            W = Ia(V, a);
          },
          configurable: !0,
        },
        preloaderSize: {
          get: function () {
            return V;
          },
          set: function (a) {
            V = Math.round(f(a, 40, 4, G));
            W = Ia(V, ua);
          },
          configurable: !0,
        },
        sourceImageRatio: {
          get: function () {
            return jb;
          },
          configurable: !0,
        },
      });
      ab();
    } else alert("RasterPro ERROR: There is no element with the specified id");
  }
  var wb = { none: 1, fit: 1, cover: 1 },
    ya = {
      circle: 0,
      circle2: 1,
      square: 0,
      square2: 1,
      line: 0,
      cell: 0,
      triangle: 0,
      triangle2: 1,
      rhomb: 0,
      rhomb2: 1,
      hexagon: 1,
    },
    Wa = { hexagon: Math.sqrt(3) / 2, circle2: Math.sqrt(3) / 2 },
    G = Number.POSITIVE_INFINITY,
    Ea = Number.NEGATIVE_INFINITY,
    vb = 0.1;
  P.instances = {};
  window.hasOwnProperty("RasterPro")
    ? alert(
        'Unable to load "raster-pro.js". Make sure the document does not contain a global variable named "RasterPro"'
      )
    : (window.RasterPro = P);
})();
